import customFetchBase from './customFetchBase';
import { createApi } from '@reduxjs/toolkit/query/react';
import { Notification } from 'Models/Notification';
import { IGenericResponse } from "../interfaces";

const GENERAL_TAG = "Notification";
const BASE_URL = "/notifications";

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: customFetchBase,
  tagTypes: [GENERAL_TAG],
  keepUnusedDataFor: 300,  // Keep cached data for 5 minutes globally
  refetchOnReconnect: true, // Refetch data when reconnected to the network
  refetchOnFocus: true, // Refetch data when the window is focused again
  endpoints: (builder) => ({

    createNotification: builder.mutation<void, FormData>({
      query: body => ({
        url: `${BASE_URL}`,
        method: "POST",
        body,
        credentials: 'include'
      }),
      invalidatesTags: () => [GENERAL_TAG],
    }),
    getNotifications: builder.query<Notification[], void>({
      query() {
        return {
          url: `${BASE_URL}`,
          credentials: 'include',
        };
      },
      transformResponse: (results: IGenericResponse<Notification[]>) => results.data,
      providesTags: () => [GENERAL_TAG],
    }),
    putCheckUnseen: builder.mutation<Notification, string>({
      query(notificationId) {
        return {
          url: `${BASE_URL}/${notificationId}/check`,
          method: "PUT",
          credentials: 'include',
        };
      },
      transformResponse: (results: IGenericResponse<Notification>) => results.data,
      invalidatesTags: () => [GENERAL_TAG],
    }),
  })
});

export const {
  useCreateNotificationMutation,
  useGetNotificationsQuery,
  usePutCheckUnseenMutation
} = notificationApi;